import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "@/store"
import type { Careers24UpsertRequestDto } from "../dtos/Careers24ConnectDto"
import {
  fetchCareers24ConnectionThunk,
  upsertCareers24ConnectionThunk,
  deleteCareers24ConnectionThunk,
  clearCareers24ConnectorState,
  selectCareers24Connection,
  selectCareers24IsLoading,
  selectCareers24IsSubmitting,
  selectCareers24IsDeleting,
  selectCareers24Error,
  selectCareers24IsSuccess,
} from "../store/careers24ConnectorSlice"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"

export function useCareers24Connector(autoLoad = true) {
  const dispatch = useDispatch<AppDispatch>()

  const orgId = useSelector((s: RootState) => selectCurrentOrganizationId(s))
  const connection = useSelector((s: RootState) => selectCareers24Connection(s))
  const isLoading = useSelector((s: RootState) => selectCareers24IsLoading(s))
  const isSubmitting = useSelector((s: RootState) =>
    selectCareers24IsSubmitting(s),
  )
  const isDeleting = useSelector((s: RootState) => selectCareers24IsDeleting(s))
  const error = useSelector((s: RootState) => selectCareers24Error(s))
  const isSuccess = useSelector((s: RootState) => selectCareers24IsSuccess(s))

  useEffect(() => {
    if (!autoLoad) return
    dispatch(clearCareers24ConnectorState())
    dispatch(fetchCareers24ConnectionThunk())
  }, [autoLoad, dispatch, orgId])

  return {
    connection,
    isLoading,
    isSubmitting,
    isDeleting,
    error,
    isSuccess,
    refresh: () => dispatch(fetchCareers24ConnectionThunk()),
    upsert: (dto: Careers24UpsertRequestDto) =>
      dispatch(upsertCareers24ConnectionThunk(dto)),
    disconnect: () => dispatch(deleteCareers24ConnectionThunk()),
  }
}
